import { render, staticRenderFns } from "./CadPerguntas.vue?vue&type=template&id=66523fe7&"
import script from "./CadPerguntas.vue?vue&type=script&lang=js&"
export * from "./CadPerguntas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports